// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type * as Types from '../util-types.js';

export type MeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MeQuery = {
  me?: {
    __typename: 'User';
    id: string;
    email: string;
    emailVerified: boolean;
    firstName: string;
    lastName: string;
    displayName: string;
    role: string;
    rolePermissions: Array<string>;
    productItems: Array<string>;
    orgId?: string | null;
    superAdmin: boolean;
    platformAdminUsers: {
      __typename: 'PlatformAdminUsersList';
      items: Array<{
        __typename: 'PlatformAdminUser';
        id: string;
        owner: boolean;
        platform: {
          __typename: 'Platform';
          id: string;
          handle: string;
          name: string;
          featureFlags: Array<string>;
          sitesSubscriptionStatus?: Types.SubscriptionStatus | null;
          sitesCount: number;
          mainSiteId?: string | null;
        };
        permissions: Array<{
          __typename: 'Permission';
          id: string;
          object: string;
          action: string;
        }>;
      }>;
    };
  } | null;
};

export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Me' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Me' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Me' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rolePermissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productItems' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'superAdmin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platformAdminUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platform' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'handle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sitesSubscriptionStatus' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sitesCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mainSiteId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'object' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
